import styled from '@emotion/styled';
export const AccountIconButton = styled.button `
  height: 4.4rem;
  padding: 0 ${({ theme }) => theme.spacing[200]};
  color: ${({ theme }) => theme.color.icon.inverse};
  display: block;
  text-decoration: none;
  background: none;
  border: none;
`;
//# sourceMappingURL=SidePanel.styled.js.map